// Generated by CoffeeScript 1.6.3
/* globals hljs*/

/**
 * Highlight code snippets in <pre> tags
 * https://highlightjs.org/
*/

itsoftApp.createModule("codeHighlight", ["pageLoad"], function() {
  var detectElem, startLoading;
  detectElem = $("pre code");
  if (!detectElem.length) {
    return false;
  }
  startLoading = function() {
    itsoftApp.loadStyle("//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.0.0/styles/default.min.css");
    return itsoftApp.loadScript("//cdnjs.cloudflare.com/ajax/libs/highlight.js/9.0.0/highlight.min.js", function() {
      DEBUG && console.log("[module codeHighlight] library loaded");
      return detectElem.each(function() {
        return hljs.highlightBlock(this);
      });
    });
  };
  return itsoftApp.modules.pageLoad.addEvent(startLoading);
});

/*
//@ sourceMappingURL=codeHighlight.map
*/
